import { useTranslation } from 'react-i18next'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const isRu = !i18n.language?.startsWith('en')

  const toggle = () => i18n.changeLanguage(isRu ? 'en' : 'ru')

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl bg-ink/10 hover:bg-ink/15 transition-colors text-sm font-semibold select-none"
      title={isRu ? 'Switch to English' : 'Переключить на русский'}
    >
      <span className="text-base leading-none">{isRu ? '🇷🇺' : '🇬🇧'}</span>
      <span className="text-ink/70">{isRu ? 'RU' : 'EN'}</span>
    </button>
  )
}
